import { type FormEvent, type ReactNode } from 'react';
import classes from './CenteredForm.module.scss';

export default function CenteredForm({
  children,
  onSubmit,
}: {
  children: ReactNode;
  onSubmit: () => Promise<void> | void;
}) {
  async function onFormSubmit(event: FormEvent<HTMLFormElement>) {
    event?.preventDefault();
    await onSubmit();
  }

  return (
    <form className={classes.root} onSubmit={onFormSubmit}>
      {children}
    </form>
  );
}
